import 'slick-carousel';

export default {
  init() {

    $(window).load(function(){
      $('#preloader').fadeOut(500);
      $('#pre-load').removeClass('pre-load-none')
    });

  },
  finalize() {
    $(function () {

      $(".slider-banner").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        dots: false,
        arrows: false,
        infinite: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
        ],
      });

      'use strict'

      $('[data-toggle="offcanvas"]').on('click', function () {
        $('.offcanvas-collapse').toggleClass('open')
      })
    })
    $(window).scroll(function () {
      if (screen.width >= 600) {
        if ($(window).scrollTop() > 40) {
          $(".header").addClass("nav-s");
        } else {
          $(".header").removeClass("nav-s");
        }
      }
    });
     // preloader
     
     // preloader

     (function() {

      'use strict';
      
        // define variables
        var items = document.querySelectorAll(".timeline li");
        
        // check if an element is in viewport
        // http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
        function isElementInViewport(el) {
          var rect = el.getBoundingClientRect();
          return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
        
        function callbackFunc() {
          for (var i = 0; i < items.length; i++) {
            if (isElementInViewport(items[i])) {
              items[i].classList.add("in-view");
            }
          }
        }
        
        // listen for events
        window.addEventListener("load", callbackFunc);
        window.addEventListener("resize", callbackFunc);
        window.addEventListener("scroll", callbackFunc);
        
      })();

      $('.oc-toggle').click(function(){
        $('.oc-toggle, .oc-nav, .oc-wrap').toggleClass('--is-active');
      });
    },
  };


// WEBPACK FOOTER //
// ./scripts/routes/common.js